import { getMailboxFolderTreeData } from 'owa-folders';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Selector for user emails of all the added shared folder users
 */
export function getSharedFolderUserEmails(mailboxInfo: MailboxInfo): string[] {
    return getMailboxFolderTreeData(mailboxInfo)?.sharedFolderUserEmails ?? [];
}
